import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { MulitViewerComponent } from './superUser/events/multi-view/mulit-viewer.component';
import { MultiViewVideoComponent } from './superUser/events/multi-view/multi-vew-video/multi-view-video.component';
import { IsAuthenticatedGuard } from './_guards/isAuthenticated.gaurd';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';
import { CeuTokensComponent } from './events/live/ceu-tokens/ceu-tokens.component';
import { LiveEventChatComponent } from './events/live/chat/live-event-chat.component';
import { LiveEventDashboardComponent } from './events/live/live-event-dashboard/live-event-dashboard.component';
import { SuggestMobileAppModalCsComponent } from './events/live/live-event-dashboard/suggest-mobile-app-modal-cs.component';
import { EventMaterialsComponent } from './events/live/materials/event-materials.component';
import { LivePeopleComponent } from './events/live/people/live-people.component';
import { EditPollComponent } from './events/live/polls/edit-poll.component';
import { LivePollsComponent } from './events/live/polls/live-polls.component';
import { PresenterViewComponent } from './events/live/presenter-view/presenter-view.component';
import { TechnicalSupportComponent } from './events/live/technical-support.component';
import { LiveQuestionsComponent } from './events/live/questions/live-questions.component';
import { LiveSuperuserComponent } from './events/live/super-user/live-superuser.component';
import { LiveTipsComponent } from './events/live/tips/live-tips.component';
import { LiveVideosComponent } from './events/live/videos/live-videos.component';
import { ChatEventLinkComponent } from './events/live/chat/chat-event-link.component';
import { StreamBoxComponent } from './superUser/streambox/stream-box.component';
import { ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';
import { LiveEventRoomViewComponent } from './events/live/room-view/live-event-room-view.component';
import { StreamboxMultiView } from './superUser/streamcase/streambox-multiview.component';
import { CaptionServerComponent } from "./superUser/events/caption-server.component";
import { CaptionBoxComponent } from "./superUser/events/caption-box.component";
import { CaptionsDisplayComponent } from "./events/captions-display.component";

@NgModule({
  declarations:[
    PresenterViewComponent,
    LiveEventDashboardComponent,
    MulitViewerComponent,
    LiveQuestionsComponent,
    TechnicalSupportComponent,
    LiveTipsComponent,
    LivePollsComponent,
    EventMaterialsComponent,
    EditPollComponent,
    CeuTokensComponent,
    LiveEventChatComponent,
    LivePeopleComponent,
    LiveVideosComponent,
    LiveSuperuserComponent,
    ChatEventLinkComponent,
    CaptionServerComponent,
    LiveEventRoomViewComponent,
    MultiViewVideoComponent,
    StreamboxMultiView,
    SuggestMobileAppModalCsComponent,
    StreamBoxComponent,
    CaptionBoxComponent,
    CaptionsDisplayComponent
  ],
  entryComponents:[
    SuggestMobileAppModalCsComponent,
  ],
  imports: [
    NgbModalModule,
    ChartsModule,
    ApplicationPipesModule.forRoot(),
    RouterModule.forChild([
     { path: ':id/presenterview', component: PresenterViewComponent, canActivate: [IsAuthenticatedGuard] },
     { path: ':id/live', component: LiveEventDashboardComponent, canActivate: [IsAuthenticatedGuard] },
     { path: ':id/presenter-dashboard', component: LiveEventDashboardComponent, canActivate: [IsAuthenticatedGuard] },
     { path: ':id/room-view', component: LiveEventRoomViewComponent, canActivate: [IsAuthenticatedGuard] },
     { path: 'multi-viewer', component: MulitViewerComponent,  canActivate: [IsAuthenticatedGuard], data:{title:'Event Multi-viewer'} },
     { path: 'streambox/:id', component: StreamBoxComponent, data:{title:'StreamBox'} },
     { path: 'streamcase/:conferenceId', component: StreamboxMultiView,  canActivate: [IsAuthenticatedGuard], data:{title:'Multiviewer'} },
     { path: 'caption-server', component: CaptionServerComponent,  canActivate: [IsAuthenticatedGuard], data:{title:'StreamCase'} },
     { path: ':conferenceSlug/caption-display', component: CaptionsDisplayComponent,  canActivate: [IsAuthenticatedGuard], data:{title:'Caption Display'} },

    ])

  ],
})
export class LiveEventsModule{}
